import axios from 'axios';
import { getApiBaseUrl } from './apiConfig';

// Create axios instance with base configuration
// credentials: 'include' ensures HTTP-only cookies are sent with requests
const api = axios.create({
  baseURL: getApiBaseUrl(),
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Send HTTP-only cookies with every request
});

// Request interceptor - cookies are sent automatically with withCredentials: true
api.interceptors.request.use(
  (config) => {
    // Default Content-Type: application/json breaks multipart FormData (no boundary) — server
    // then sees empty req.body and updates silently fail while still returning 200.
    if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
      delete config.headers['Content-Type'];
      delete config.headers['content-type'];
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Unauthorized - redirect to login only if not already on login page
      // Prevent infinite redirect loops
      if (window.location.pathname !== '/login') {
        // Use a small delay to prevent rapid redirects
        setTimeout(() => {
          window.location.href = '/login';
        }, 100);
      }
    }
    return Promise.reject(error);
  }
);

export default api;
